import React, { Component } from 'react';
import { fetchPosts } from '../core/api';
import Carousel from './carousel';
import List from './list';

interface Props {
    element: any;
}
interface State {
    posts: any;
    id: string;
    domElement:any;
    type: string;
}
class SingleFeeder extends Component<Props, State> {
    state:State = {posts: [], id: '', domElement:null, type: 'list'};

    async componentDidMount() {        
        const { element } = this.props;
        const tags: string = element.getAttribute('tags') || '';
        const categories: string = element.getAttribute('categories') || '';
        const total: string = element.getAttribute('total') || '';
        const tags_exclude: string = element.getAttribute('tags-exclude') || '';
        const categories_exclude: string = element.getAttribute('categories-exclude') || '';
        const id:string = element.getAttribute('id') || '';
        const type: string = element.getAttribute('type') || '';

        // Fetch posts
        const params = ('tags=' + tags + '&categories=' + categories + '&per_page=' + total + '&tags_exclude=' + tags_exclude + '&categories_exclude=' + categories_exclude).replace(/[^=&]+=(&|$)/g, '').replace(/&$/, '');
        const data = await fetchPosts(params);
        this.setState({...this.state, posts:data, id: id, domElement:element, type: type});
        
    }
    public render() { 
        const{type,posts} = this.state;
        return (
            <div className="App">
                {posts.length > 0 ?
                (type === 'carousel')? <Carousel data={this.state}/>:<List data={this.state} />: 'Loading...'}
            </div>
        )
    }
}


export default SingleFeeder;